import { isEmpty } from 'lodash';
import config from '../../config';
import fetch from '../fetch';
import logger from '../logger';

// API responsible for getting the grants of profile to employer accounts
const GrantsAPI = () => {
  const endpoint = `${config.apiUrl}/v2/grants`;

  const getProfileGrants = async (ctx) => {
    try {
      const response = await fetch(`${endpoint}/own`, {
        method: 'GET',
        ctx,
      });
      return response;
    } catch (error) {
      logger.logDebug('Encountered error while calling GrantsAPI', error);
      throw error;
    }
  };

  const getEmployerGrants = async (organizationId, fetchOptions = {}, ctx = {}) => {
    try {
      const response = await fetch(`${endpoint}/${organizationId}`, {
        method: 'POST',
        ...fetchOptions,
        ctx,
      });
      return response.data;
    } catch (error) {
      logger.logDebug('Encountered error while calling GrantsAPI', error);
      throw error;
    }
  };

  const getUserGrantsByIndexedKeys = async (data, fetchOptions = {}, ctx = {}) => {
    try {
      const response = await fetch(`${endpoint}/get-grants?page_size=250`, {
        method: 'POST',
        body: data,
        ...fetchOptions,
        ctx,
      });
      return response.data;
    } catch (error) {
      logger.logDebug('Encountered error while calling GrantsAPI', error);
      throw error;
    }
  };

  const updateGrant = async (employerKey, data, fetchOptions, ctx = {}) => {
    try {
      const response = await fetch(`${endpoint}/${employerKey}`, {
        method: 'PUT',
        body: data,
        ...fetchOptions,
        ctx,
      });
      return response.data;
    } catch (error) {
      logger.logDebug('Encountered error while calling GrantsAPI', error);
      throw error;
    }
  };

  const getUsersWithUpwardGrants = async (jfOrganizationId, fetchOptions = {}, ctx = {}) => {
    try {
      const response = await fetch(`${config.apiUrl}/v2/upward-grants?jf_organization_id=${jfOrganizationId}`, {
        method: 'GET',
        ...fetchOptions,
        ctx,
      });

      if (!isEmpty(response.data)) {
        return response.data?.filter(item => item?.profileKey !== 'undefined');
      }

      return response.data;
    } catch (error) {
      logger.logDebug('Encountered error while retrieving upward grants.', error);
      throw error;
    }
  };

  const getUpwardGrantsByProfile = async (profileKey, fetchOptions = {}, ctx = {}) => {
    try {
      const response = await fetch(`${config.apiUrl}/v2/upward-grants/${profileKey}`, {
        method: 'GET',
        ...fetchOptions,
        ctx,
      });
      return response.data;
    } catch (error) {
      logger.logDebug('Encountered error while retrieving upward grants.', error);
      throw error;
    }
  };

  // Internal-only (JEA) account diagnostics (LUT-545). POST body on purpose: profile keys
  // identify people and must not appear in URLs. The server enforces the boundary; a
  // non-JEA caller gets 401 regardless of what the UI renders.
  const getAccountDiagnostics = async (organizationId, profileIds, ctx = {}) => {
    try {
      const response = await fetch(`${endpoint}/${organizationId}/account-diagnostics`, {
        method: 'POST',
        body: {
          data: {
            profile_ids: profileIds,
          },
        },
        ctx,
      });
      return response.data;
    } catch (error) {
      logger.logDebug('Encountered error while calling GrantsAPI', error);
      throw error;
    }
  };

  const updateUpwardGrants = async (profileKey, data, fetchOptions, ctx = {}) => {
    try {
      const response = await fetch(`${config.apiUrl}/v2/upward-grants/${profileKey}`, {
        method: 'PUT',
        body: {
          data,
        },
        ...fetchOptions,
        ctx,
      });
      return response.data;
    } catch (error) {
      logger.logDebug('Encountered error while calling GrantsAPI', error);
      throw error;
    }
  };

  return { getProfileGrants,
    getEmployerGrants,
    updateGrant,
    getUserGrantsByIndexedKeys,
    getUpwardGrantsByProfile,
    getAccountDiagnostics,
    updateUpwardGrants,
    getUsersWithUpwardGrants };
};

export default GrantsAPI;
